import * as React from 'react';
import { connect } from 'react-redux';
import PowerBiViewController from './PowerBiViewController';
import { IPbiReport } from './business-objects/types';
import ExportButton from './ExportButton';

export interface IViewPbiReportProps {
  activeReport: IPbiReport;
}

class ViewPbiReport extends React.Component<IViewPbiReportProps> {
  public render() {
    return (
      <div>
        {this.props.activeReport && (
          <PowerBiViewController
            reportId={this.props.activeReport.reportId}
            type='report'
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    activeReport: state.PowerBI.activeReport,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPbiReport);
